import { render, staticRenderFns } from "./ApprovalRejected.vue?vue&type=template&id=44572d45&"
import script from "./ApprovalRejected.vue?vue&type=script&lang=ts&"
export * from "./ApprovalRejected.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports